import { observer } from "mobx-react-lite";
import IframeComponentStyled from "./iframe.component.styled";
import {useCallback} from 'react';
import { useStore } from "../../hooks/store.hook";
import { StoreEnum } from "../../enums/store.enum";
import {
    ClickAwayListener, Container, Divider, IconButton,
  } from '@mui/material';
import { Close } from '@mui/icons-material';

const IframeComponent = observer(() => {
     
    const uiStore = useStore(StoreEnum.UiStore);

    const closeButtonClick = useCallback(() => {
        if(uiStore.iframeOpen){
            uiStore.dismissIframe();
        }
    }, [uiStore]);

    const onClickAwayHandler = useCallback(() => {
        if(uiStore.iframeOpen){
            uiStore.dismissIframe();
        }
    }, [uiStore]);

    return (
       <IframeComponentStyled
            isOpen={uiStore.iframeOpen}
       >
        {
            uiStore.iframeOpen ? (
                <ClickAwayListener
                    onClickAway={onClickAwayHandler}
                    mouseEvent="onMouseDown"
                >
                    <div className="inner-iframe-contents">
                        <div className="iframe-header">
                            <Container maxWidth="xl">
                                <div className="iframe-header-contents">
                                    <div className="iframe-title">
                                        {/* { 'TITLU '} */}
                                    </div>
                                    <div className="iframe-buttons">
                                        <IconButton onClick={closeButtonClick} size="small">
                                            <Close />
                                        </IconButton>
                                    </div>
                                </div>
                            </Container>
                            <Divider />
                        </div>
                        <div className="iframe-body">
                            <iframe style={{width: '100%', height: '100%'}} src={uiStore.iframeUrl}></iframe>
                        </div>
                    </div>
                </ClickAwayListener>
                
            ) : ('')
        }
       </IframeComponentStyled>
    )
});

export default IframeComponent;